// @ts-nocheck
import loadStoreListsData from "@store/Framework/Store/Data/StoreLists/Handlers/LoadStoreLists";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler;

export const DispatchLoadStoreLists: HandlerType = props => {
    props.dispatch(loadStoreListsData(props.getState().store.pages.storeLists.getStoreListsParameter));
};

export const chain = [DispatchLoadStoreLists];

const loadStoreLists = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadStoreLists");
export default loadStoreLists;
